import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./style.scss";
import TopNavigation from "../../components/TopNavigation";
import * as PageRoutes from "../../utils/route_pages";
import * as Assets from "../../utils/svg_assets";
import { FormGenerator, InputModel } from "../../components/FormGenerator";
import { initial_edit_profile } from "../../utils/initial_payload";
import { UserDetailDM } from "../../data_model/user_detail_dm";
import { Base } from "../../components/RootLayout";
import "react-datepicker/dist/react-datepicker.css";
import { InformationDialog } from "../../components/DialogCollection";
import { useNavigate } from "react-router-dom";
import ApiUtils from "../../utils/api_utils";

const EditProfilPage = (props) => {
  const profile = UserDetailDM.fromJson(props.profile);
  const navigate = useNavigate();
  const initialValues = initial_edit_profile(profile.toMapEditProfile());

  const [payload, setPayload] = useState(initialValues);
  const [dialog, setDialog] = useState({
    show: false,
    message: "",
    is_success: false,
  });
  const { updateUserProfile, login } = props;

  const editProfile = (values) => {
    let data = InputModel.modelToMaps({ models: values });

    if (!props.profile.is_staff) {
      data["expiry_date"] = props.profile.expiry_date;
    }
    updateUserProfile(data)
      .then(function (response) {
        var new_profile = UserDetailDM.fromJson(response.data);
        props.setProfile({ profile: new_profile });
        // console.log("New Profile", new_profile);
        setDialog({
          show: true,
          message: "Update Profile Success",
          is_success: true,
        });
      })
      .catch(function (error) {
        setDialog({
          show: true,
          message: "Update Profile Failed",
          is_success: false,
        });
      });
    // console.log(data);
  };
  const handleClick = (event) => {
    navigate(PageRoutes.editAvatarProfile);
  };

  const renderPhotoProfile = () => {
    let photo_profile;

    if (profile.profile_pic_url) {
      photo_profile = (
        <div
          className="pp-img"
          style={{
            backgroundImage: `url(${ApiUtils.validateImgUrl({
              url: profile.profile_pic_url,
            })})`,
          }}
        >
          <div className="edit-btn" onClick={handleClick}>
            <img src={Assets.iconEditActive} alt="edit_item_image" />
          </div>
        </div>
      );
    } else {
      photo_profile = (
        <div className="pp-img">
          <img
            src={Assets.iconProfile}
            className="profile-img-plh"
            alt="profile_item_image"
          />
          <div className="edit-btn" onClick={handleClick}>
            <img src={Assets.iconEditActive} alt="edit_item_image" />
          </div>
        </div>
      );
    }

    return photo_profile;
  };

  const handleDialogClose = () => {
    setDialog({
      ...dialog,
      show: false,
    });

    if (dialog.is_success) {
      navigate(PageRoutes.editProfile);
    }
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Edit Profile"
        toPath={PageRoutes.setting}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />

      {renderPhotoProfile()}
      <FormGenerator
        key="form-generator"
        inputs={payload}
        onSubmit={(values) => editProfile(values)}
        loginType={login.organization_username_field}
      />
      <InformationDialog
        message={dialog.message}
        closeLabel="OK"
        show={dialog.show}
        onHide={handleDialogClose}
      />
    </Base>
  );
};

const mapStateToProps = (state) => ({
  profile: state.ProfileSM.profile,
  login: state.LoginSM.login,
});

const mapDispatchToProps = (dispatch) => ({
  updateUserProfile: dispatch.ProfileSM.updateUserProfile,
  setProfile: dispatch.ProfileSM.setProfile,
});

export default connect(mapStateToProps, mapDispatchToProps)(EditProfilPage);
